import SEOLandingTemplate from './SEOLandingTemplate';

export default function FreeKeywordToolPage() {
  return (
    <SEOLandingTemplate
      title="Free Keyword Tool"
      metaTitle="Free Keyword Tool - Volume, Difficulty & CPC Data | Sungresh"
      metaDescription="Find keyword ideas with search volume, difficulty score, CPC, and intent, powered by DataForSEO. Free credits on signup, no credit card required."
      h1="Free Keyword Tool"
      sub="Enter a seed term and get keyword ideas with search volume, difficulty, CPC, and search intent, sourced from DataForSEO."
      keywords="free keyword tool, keyword tool free, free keyword research tool"
      ctaLink="/keywords/magic"
      ctaText="Try the Keyword Tool"
      features={[
        { icon: '🔍', title: 'Search Volume', desc: 'Monthly search volume per keyword' },
        { icon: '⚡', title: 'Difficulty Score', desc: 'A 0-100 estimate of ranking difficulty' },
        { icon: '💰', title: 'CPC & Competition', desc: 'Advertiser competition and cost-per-click data' },
        { icon: '🎯', title: 'Search Intent', desc: 'Informational, commercial, or transactional' },
        { icon: '❓', title: 'Question Keywords', desc: 'Question-phrased variations, useful for FAQ content' },
      ]}
      faqs={[
        { q: 'How many keyword ideas does one search return?', a: 'Typically over 100 related ideas from a single seed keyword, depending on how broad the topic is.' },
        { q: 'How do I find easier keywords to target?', a: 'Sort by difficulty score and look for lower-difficulty terms that still have meaningful search volume — this gives you a realistic starting list rather than only the most competitive head terms.' },
        { q: 'Does this include long-tail and question keywords?', a: 'Yes — filter by keyword type to see broad match, phrase match, question-style, and related terms separately.' },
      ]}
    />
  );
}
